import { ObterUmItemAlbumRastreavel } from './obterUmItemAlbumRastreavel';
import { DeletarItemAlbumRastreavel } from './deletarItemAlbumRastreavel';
import { ObterItensAlbumRastreavel } from './obterItensAlbumRastreavel';
import { CriarItemAlbumRastreavel } from './criarItemAlbumRastreavel';

(new ObterUmItemAlbumRastreavel()).executar();
(new DeletarItemAlbumRastreavel()).executar();
(new ObterItensAlbumRastreavel()).executar();
(new CriarItemAlbumRastreavel()).executar();
